import PageWrapper from 'components/utils/PageWrapper';
import ExpressJobs from 'pages/ExpressJobs';

export const expressJobsRoutes = {
    path: '/express-jobs',
    element: (
        <PageWrapper titleId="express_jobs_title">
            <ExpressJobs />
        </PageWrapper>
    ),
};
